import React, { ComponentProps, CSSProperties } from 'react';
import { StyleSheet, View } from 'react-native';
import { palettes } from '../../../config';
import { usePrimaryColors } from '../../../hooks/usePrimaryColors';
import { getResponsiveStyle } from '../../../utils/getResponsiveStyle';

export type TDateTimeType = 'datetime-local' | 'date' | 'time';

export type TDateTimeTypeProps = {
	dateTimeProps?: Omit<ComponentProps<'input'>, 'type' | 'style' | 'min'>;
	inputStyles?: CSSProperties;
	type?: TDateTimeType;
	min?: string;
};

export const WebDateTimePicker = ({
	dateTimeProps,
	inputStyles,
	type,
	min,
}: TDateTimeTypeProps) => {
	const primary = usePrimaryColors();
	return (
		<View style={reactNativeStyles.container}>
			<input
				{...dateTimeProps}
				type={type}
				style={{ ...reactStyles, ...inputStyles, outline: primary[0] }}
				min={min}
			/>
		</View>
	);
};

const reactNativeStyles = StyleSheet.create({
	container: {
		flex: 1,
		width: '100%',
	},
});

const reactStyles: CSSProperties = {
	borderRadius: 6,
	border: `1px solid ${palettes.grey[4]}`,
	height: getResponsiveStyle(48, 'dimensions'),
	fontSize: getResponsiveStyle(16, 'font'),
	lineHeight: getResponsiveStyle(14, 'font'),
	paddingLeft: getResponsiveStyle(24),
	paddingRight: getResponsiveStyle(24),
};
